import _ from 'lodash'

import { createSectionCreator, createField } from '../utils'
import { checker } from '../selectors'

const diagnosisField = (app, id) => {
  const isShowRemoveButton = !id.includes('[0]')

  return _.compact([
    createField(`${id}.what`, [
      {
        label: 'ตรวจอะไร',
        id: `${id}.what`,
        c: 'TextInput',
        required: true,
        p: {},
      },
    ]),
    createField(`${id}.when`, [
      {
        label: 'เมื่อใด',
        id: `${id}.when`,
        c: 'TextInput',
        required: true,
        p: {},
      },
    ]),
    createField(`${id}.where`, [
      {
        label: 'สถานที่ตรวจ',
        id: `${id}.where`,
        c: 'TextInput',
        required: true,
        p: {},
      },
    ]),
    createField(`${id}.result`, [
      {
        label: 'ผลการตรวจ',
        id: `${id}.result`,
        c: 'TextInput',
        required: true,
        p: {},
      },
    ]),
    createField(`${id}.notice`, [
      {
        label: 'ข้อสังเกตโดยแพทย์',
        id: `${id}.notice`,
        c: 'TextInput',
        required: true,
        p: {},
      },
    ]),
    isShowRemoveButton &&
      createField(
        `${id}.remove`,
        [
          {
            id: `${id}.remove`,
            c: 'Button',
            p: {
              icon: 'remove',
              children: 'ลบ',
              mergeProps: ({ removeValue }) => ({
                onClick: () => removeValue(id),
              }),
              style: {
                fontSize: '0.8725rem',
                padding: '0.125rem 0.5rem',
              },
            },
          },
        ],
        {
          style: {
            position: 'absolute',
            top: '0',
            right: '0',
          },
        }
      ),
  ])
}

const addDiagnosis = (app, id) => [
  createField(`${id}.addNew`, [
    {
      id,
      c: 'Button',
      p: {
        children: 'เพิ่มข้อมูล',
        icon: 'add',
        block: true,
        mergeProps: ({ setValue }) => ({
          onClick: () => setValue(id, null),
        }),
      },
    },
  ]),
]

export default (sectionId, sectionLabel) => (app, id) => {
  const diagnosisDetail = _.get(app, `${id}.diagnosisMRTA.detail`, [null])
  const { isYes, isNo } = checker(app)

  return _.compact(
    isYes(`${id}.diagnosisMRTA.checked`) &&
      _.reduce(
        diagnosisDetail,
        (result, el, index) => [
          ...result,
          createSectionCreator(diagnosisField)(`${sectionId}[${index}]`, null, null, `รายละเอียดที่ ${index + 1}`)(
            app,
            `${id}.diagnosisMRTA.detail[${index}]`
          ),
        ],
        []
      ).concat(
        diagnosisDetail.length < 10 &&
          createSectionCreator(addDiagnosis)(sectionId)(app, `${id}.diagnosisMRTA.detail[${diagnosisDetail.length}]`)
      )
  )
}
